import React from 'react'
import RoleTable from 'components/Tables/Role/RoleTabe'
import FaqsTable from 'components/Tables/Faqs/FaqsTable'

const ListFAQ = () => {
  return (
    <div><FaqsTable /></div>
  )
}

export default ListFAQ